import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { Languages } from 'src/app/shared/models/enums.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { ETenderStatus } from 'src/app/shared/models/e-tender.model';
import { DomSanitizer } from '@angular/platform-browser';
//import { Key } from 'protractor';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-tender-list',
  templateUrl: './tender-list.component.html',
  styles: []
})
export class TenderListComponent implements OnInit {
  private collection: Listing;
  @ViewChild('ETenderList',{static: false}) gridView: GridViewComponent;
  pageSize = 10;
  type: number = null;
  category: number = null;
  tenderNumber = '';
  fileNumber = '';
  tenderMethod: number = null;
  private itemsMenu: MenuItem[] = [];
  creationDateFrom = '';
  creationDateTo = '';
  dateFromFormatted = '';
  dateToFormatted = '';
  offerDeadlineFrom = '';
  offerDeadlineTo = '';
  offerDeadlineFromFormatted = '';
  offerDeadlineToFormatted = '';
  hideExportButton: boolean;
  showFromDateGreaterThanTodayDateMessage: boolean;
  showFromDateGreaterThanToDateMessage: boolean;
  showOfferDeadlineFromDateGreaterThanTodayDateMessage: boolean;
  showOfferDeadlineFromDateGreaterThanToDateMessage: boolean;
  TenderTypes: LookUp[];
  TenderMethods: LookUp[];
  TenderCategories: LookUp[];
  displayedLang: string;
  HasMenu = true;
  HasMenuButtons = true;
  IsHtml = false;
  currentUser: string;
  constructor(private global: GlobalServices, private etenderSrv: EtenderService, private lookupSrv: LookupService,
              private alertService: AlertService, private translate: TranslateService, public datepipe: DatePipe,
              private sanitized: DomSanitizer, private router: Router, private authSrevice: AuthenticationService) {
    this.displayedLang = this.global.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.currentUser = this.authSrevice.currentUserValue.Email;
    // this.currentUser = this.global.user.Email;
  }


  ngOnInit() {
    this.loadLookups();
    this.loadData();

  }
  loadCollectionCompleted() {
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      'ETender/GetETenderPaged?pageIndex={PAGEINDEX}&pageSize=' + this.pageSize +
      '&language=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En') +
      '&creationDateFrom=' + this.dateFromFormatted + '&creationDateTo=' + this.dateToFormatted + '&type=' + this.type +
      '&category=' + this.category + '&tenderNumber=' + this.tenderNumber + '&fileNumber=' + this.fileNumber +
      '&offerDeadlineFrom=' + this.offerDeadlineFromFormatted + '&offerDeadlineTo=' + this.offerDeadlineToFormatted +
      '&tenderMethod=' + this.tenderMethod + '&currentUser=' + this.currentUser,
      'ADMIN_USER.ETENDER_OBJECT', this.itemsMenu, '', '', 'GetETenderPaged');
    this.global.isLoaderEnabled = false;
  }
  ExportExcel() {
    this.translate.get('ADMIN_USER.ETENDER_EXCEL_OBJECT').subscribe((response: string) => {
      this.etenderSrv.ExportETenderExcel(JSON.stringify(response),
        (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En'), this.dateFromFormatted,
        this.dateToFormatted, this.type , this.category, this.tenderNumber, this.fileNumber, this.offerDeadlineFromFormatted,
        this.offerDeadlineToFormatted, this.tenderMethod, this.currentUser);
    });
  }
  isFromDateGreaterThanToDate(): boolean {
    let isFromDateGreaterThanToDate = false;
    if (this.creationDateTo != '') {
      isFromDateGreaterThanToDate = new Date(this.creationDateFrom) > new Date(this.creationDateTo);
    }
    return isFromDateGreaterThanToDate;
  }
  isFromDateGreaterThanTodayDate(): boolean {
    let isFromDateGreaterThanTodayDate = false;
    const today = new Date();
    const todayDate = this.datepipe.transform(today, 'MM/dd/yyyy');
    const selectedCreationDateFrom = this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    isFromDateGreaterThanTodayDate = selectedCreationDateFrom > todayDate;
    return isFromDateGreaterThanTodayDate;
  }
  isOfferDeadlineFromDateGreaterThanToDate(): boolean {
    let isOfferDeadlineFromDateGreaterThanToDate = false;
    if (this.offerDeadlineTo != '') {
      isOfferDeadlineFromDateGreaterThanToDate = new Date(this.offerDeadlineFrom) > new Date(this.offerDeadlineTo);
    }
    return isOfferDeadlineFromDateGreaterThanToDate;
  }

  resetData() {
    this.creationDateFrom = '';
    this.creationDateTo = '';
    this.type = null;
    this.category = null;
    this.tenderNumber = '';
    this.fileNumber = '';
    this.tenderMethod = null;
    this.dateFromFormatted = '';
    this.dateToFormatted = '';
    this.offerDeadlineFrom = '';
    this.offerDeadlineTo = '';
    this.offerDeadlineFromFormatted = '';
    this.offerDeadlineToFormatted = '';
    this.hideExportButton = false;
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.loadData();

  }
  loadData() {
    if (this.isFromDateGreaterThanTodayDate()) {
      this.showFromDateGreaterThanTodayDateMessage = true;
      return;
    }
    if (this.isFromDateGreaterThanToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }
    if (this.isOfferDeadlineFromDateGreaterThanToDate()) {
      this.showOfferDeadlineFromDateGreaterThanToDateMessage = true;
      return;
    }
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showOfferDeadlineFromDateGreaterThanTodayDateMessage = false;
    this.showOfferDeadlineFromDateGreaterThanToDateMessage = false;
    this.creationDateFrom = this.creationDateFrom == null ? '' : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? '' : this.creationDateTo;
    this.offerDeadlineFrom = this.offerDeadlineFrom == null ? '' : this.offerDeadlineFrom;
    this.offerDeadlineTo = this.offerDeadlineTo == null ? '' : this.offerDeadlineTo;
    this.type = this.type == null ? null : this.type;
    this.category = this.category == null ? null : this.category;
    this.tenderNumber = this.tenderNumber == null ? '' : this.tenderNumber;
    this.fileNumber = this.fileNumber == null ? '' : this.fileNumber;
    this.tenderMethod = this.tenderMethod == null ? null : this.tenderMethod;
    this.global.isLoaderEnabled = true;
    this.dateFromFormatted = this.creationDateFrom == '' ? '' : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    this.dateToFormatted = this.creationDateTo == '' ? '' : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
    this.offerDeadlineFromFormatted = this.offerDeadlineFrom == '' ? '' : this.datepipe.transform(this.offerDeadlineFrom, 'MM/dd/yyyy');
    this.offerDeadlineToFormatted = this.offerDeadlineTo == '' ? '' : this.datepipe.transform(this.offerDeadlineTo, 'MM/dd/yyyy');
    this.etenderSrv.GetETenderPaged(0, this.pageSize, this.dateFromFormatted, this.dateToFormatted, this.type,
      this.category, this.tenderNumber, this.fileNumber, this.offerDeadlineFromFormatted, this.offerDeadlineToFormatted,
      this.tenderMethod, this.currentUser, (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En')).subscribe(
        d => {
          this.collection = d.Data;
          this.hideExportButton = this.collection.Collection.length > 0 ? false : true;
        },
        () => console.log('Something went wrong!!'),
        () => this.loadCollectionCompleted()
      );
  }
  loadLookups() {
    this.global.isLoaderEnabled = true;
    this.TenderTypes = [];
    this.lookupSrv.getTenderLookups().subscribe(d => {
      this.TenderTypes = d.Data.TenderTypes;
      this.TenderMethods = d.Data.TenderMethods;
      this.TenderCategories = d.Data.Categories;
      this.global.isLoaderEnabled = false;
    });
  }
  Cancel(id: string) {
    if (id) {
      this.router.navigate(['/CancelTender'], { state: { data: { tenderId: id } } });
    }
  }
  Edit(id: string) {
    if (id) {
      this.router.navigate(['/CreateTender'], { state: { data: { tenderId: id } } });
    }
  }
  InviteAdditionalSupplier(id: string) {
    if (id) {
      this.router.navigate(['/InviteAdditionalSupplier'], { state: { data: { tenderId: id } } });
    }
  }
  Evaluate(id: string) {
    if (id) {
      this.router.navigate(['/etenderEvaluation'], { state: { data: { tenderId: id } } });
    }
  }
  DefineDeadline(id: string) {
    if (id) {
      this.router.navigate(['/DefineTenderDeadline'], { state: { data: { tenderId: id } } });
    }
  }
  Delete(id: string) {
    if (id) {
      this.etenderSrv.DeleteTender(id).subscribe(d => {
        this.global.isLoaderEnabled = true;
        if (d.Success) {
          this.alertService.success(this.translate.instant('ADMIN_USER.E_TENDER_FORM.DELETE_TENDER_SUCCESS_MESSAGE'));
          this.loadData();
        } else {
          this.alertService.error(d.ErrorMessages[0]);
        }
        this.global.isLoaderEnabled = false;
      });
    }
  }
  View(id, type) {
    if (id) {
      if (type == this.translate.instant('ADMIN_USER.E_TENDER_FORM.PUBLIC_BIDDING')) {
        this.router.navigate(['/ViewTender'], { state: { data: { tenderId: id } } });
      } else {
        this.router.navigate(['/TenderViewAllFieldsComponent'], { state: { data: { tenderId: id} } });
      }
    }
  }
  ViewSupplierEvaluation(fileNumber) {
    if (fileNumber) {
      this.router.navigate(['/etenderSupplierEvaluationList'], { state: { data: { FileNumber: fileNumber} } });
    }
  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
  Action: string;
}
